import type { FC, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/InfoOutlined';

interface GridInfoFooterProps {
  /** Plain text rendered as body2; ignored when `children` is given. */
  message?: ReactNode;
  showIcon?: boolean;
  gap?: number;
  children?: ReactNode;
}

const GridInfoFooter: FC<GridInfoFooterProps> = ({ message, showIcon = false, gap = 1, children }) => {
  if (!children && !message) return null;

  return (
    <Box
      sx={(theme) => ({
        p: 2,
        height: 54,
        minHeight: 54,
        display: 'flex',
        alignItems: 'center',
        gap,
        borderTop: `1px solid ${theme.palette.divider}`,
        cursor: 'default',
      })}
    >
      {showIcon ? <InfoIcon color="primary" sx={{ fontSize: 21 }} /> : null}
      {children ?? <Typography variant="body2">{message}</Typography>}
    </Box>
  );
};

export default GridInfoFooter;
